<template>
    <div
        class="quiz-wrapper tw-rounded tw-relative tw-flex tw-flex-col tw-bg-white tw-m-6 md:tw-h-auto md:tw-mx-auto md:tw-mt-5 tw-overflow-hidden">
        <ajaxspinner></ajaxspinner>
        <template v-if="quiz_ready && timer_passed === false">
            <quiz-start :quiz="quiz" :quizSettings="quizSettings" v-if="!quiz_started"></quiz-start>

            <quiz-top v-if="quiz_started" :current_question_index="current_question_index" :activeQuestion="activeQuestion"
                      :display_quiz_ended="display_quiz_ended" :quizSettings="quizSettings"></quiz-top>

            <quiz-end v-if="display_quiz_ended && current_question_index+1 === getAmountOfQuestions"></quiz-end>

            <template v-else-if="quiz_started">
                <div class="quiz-question-wrapper tw-flex tw-flex-col tw-flex-1 tw-px-6 tw-overflow-hidden">
                    <div v-bar>
                        <div class="tw-h-full">
                            <transition :name="direction" mode="out-in">
                                <quiz-question :question="activeQuestion" v-for="question in questions"
                                               :key="question.id" v-if="question.id === activeQuestion.id"
                                               :current_question_index="current_question_index"></quiz-question>
                            </transition>
                        </div>
                    </div>
                </div>
            </template>
            <quiz-bottom :active_question="activeQuestion" :display_quiz_ended="display_quiz_ended"
                         :questions="questions" :timer_passed="timer_passed" :course_id="parseInt(course_id)"></quiz-bottom>
        </template>
        <template v-else-if="timer_passed">
            <quiz-time-ran-out></quiz-time-ran-out>

            <quiz-bottom :active_question="activeQuestion" :display_quiz_ended="display_quiz_ended"
                         :questions="questions" :timer_passed="timer_passed" :course_id="parseInt(course_id)"></quiz-bottom>
        </template>
    </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import { EventBus } from '../../lib/event-bus.js';

let _ = require('lodash');

export default {
	name: 'Quiz',

	props: ['quiz_id', 'course_id'],

	computed: {
		...mapState('quiz',
			['quiz',
				'quizSettings',
				'given_answers',
				'questions',
				'last_answer_given',
				'current_question_index',
				'quiz_started',
				'display_quiz_ended',
				'answer_confirmed',
				'timer_passed',
				'quiz_finished',
			],
		),

		...mapGetters('quiz', ['getAmountOfQuestions']),

		activeQuestion() {
			return this.questions[this.current_question_index];
		},
	},

	data() {
		return {
			quiz_ready: false,
			direction: '',
		};
	},

	mounted() {
		this.getQuiz();

		EventBus.$on('quiz-question-changed', (next) => {
			this.direction = next ? 'next' : 'prev';
		});
	},

	methods: {
		getQuiz() {
			this.$store.commit('toggleSpinner', true);

			this.$store.dispatch('quiz/getQuiz', parseInt(this.quiz_id))
				.then(() => {
					this.getQuizSettings();
				}).catch(() => {

				});
		},

		getQuizSettings() {
			let self = this;
			this.$store.dispatch('quiz/getQuizSettings')
				.then(function () {
					self.getLastQuizResponseId();
				});
		},

		getLastQuizResponseId() {
			let self = this;
			this.$store.dispatch('quiz/getQuizResponseId', true)
				.then(() => {
					self.getGivenAnswers();
				});
		},

		getGivenAnswers() {
			this.$store.dispatch('quiz/getGivenAnswers', true)
				.then(() => {
					this.getQuizQuestions();
				});
		},

		getQuizQuestions() {
			if (this.last_answer_given !== 0) {
				//get the index of the question that was last answered
				let last_answer_index = this.$store.getters['quiz/getQuestionIndexById'](this.last_answer_given);

				// if the answer is not of index -1 (these are responses that relate to questions that have been deleted)
				if (last_answer_index !== -1) {
					//if we dont want to show feedback, move onto the next question
					if (this.quizSettings.direct_feedback !== '1') {
						//if the last answered question wasnt the last one
						if (last_answer_index + 1 !== this.getAmountOfQuestions) {
							//move to that question
							this.$store.commit('quiz/navigateToQuestionByIndex', this.$store.getters['quiz/getQuestionIndexById'](this.last_answer_given) + 1);
						} else {
							//quiz has ended, so we navigate to the last question and activate the end display
							this.$store.commit('quiz/navigateToQuestionByIndex', last_answer_index);
							this.$store.commit('quiz/toggleQuizEndDisplay', true);
						}
					} else {
						//else show the question that was last answered and whether it was correct or not
						this.$store.commit('quiz/navigateToQuestionByIndex', last_answer_index);
					}
				}

				this.$store.commit('quiz/startQuiz', true);
			}

			this.quiz_ready = true;

			this.$store.commit('toggleSpinner', false);
		}
	},
};
</script>

<style lang="scss">
.quiz-wrapper {
    height: calc(100vh - 150px);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05) !important;
    transition: box-shadow 0.3s ease-in-out, background 0.3s ease-in-out;

    .tw-rounded {
        border-radius: 0.25rem !important;
    }

    .tw-rounded-lg {
        border-radius: 0.5rem !important;
    }

    &:before {
        @apply tw-z-10 tw-absolute tw-left-0 tw-right-0 tw-m-auto;
        width: 96%;
        content: "";
        top: 50px;
        height: 20px;
        background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0), #fff);
    }

    &:after {
        @apply tw-z-10 tw-absolute tw-left-0 tw-right-0 tw-m-auto;
        width: 96%;
        content: "";
        bottom: 76px;
        height: 30px;
        background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #fff);
    }

    .vb {
        width: 100%;
        height: 100%;
    }

    @screen md {
        width: 100%;
        height: 500px;
    }

    &.cinema-mode {
        background: #313131;
        box-shadow: none;

        &:before {
            background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0), #313131);
        }

        &:after {
            background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #313131);
        }

        .quiz-question-wrapper {
            .quiz-question {
                color: #fff;
            }

            .mc-option {
                border-color: #828282;

                .mc-answer {
                    color: #2d3748;
                    background-color: #828282;
                }

                h2 {
                    color: #d1d3d4;
                }
            }

            .answer-confirmed-overlay {
                background: rgba(49, 49, 49, 0.75);
            }
        }

        .quiz-bottom-wrapper {
            border-color: #292929;

            .quiz-bottom {
                background: #3e3e3e;
            }
        }
    }
}

.next-enter-active, .next-leave-active, .prev-enter-active, .prev-leave-active {
    transition: opacity 0.1s ease-in, transform 0.1s ease-in;
    opacity: 1;
    transform: translateX(0px);
}

.next-enter, .prev-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

.next-leave-to, .prev-enter {
    opacity: 0;
    transform: translateX(-20px);
}
</style>